import React, { useState, useEffect, useRef } from 'react';
import { Carousel, Track, Slide } from '@fiverr-private/carousel';
import { Container } from '@fiverr-private/layout_components';
import { Image } from '@fiverr-private/media';
import { useEnteredView } from '@fiverr-private/hooks';
import { sendBiankaImpression } from '../../shared/biEvents';
import { EVENT_NAMES } from '../../shared/biEvents/eventNames';
import { TRUSTED_COMPANIES } from './constants';
import { sectionCustomClass } from './styles.ve.css';

const TrustedBy: React.FC<{ isV16?: boolean }> = ({ isV16 = false }) => {
  const [isLargeScreen, setIsLargeScreen] = useState(false);
  const [currentSlideIndex, setCurrentSlideIndex] = useState(0);
  const intervalRef = useRef<NodeJS.Timeout | null>(null);
  const observableRef = useRef<HTMLDivElement>(null);

  useEnteredView(observableRef, {
    threshold: 1,
    onEntered: () => {
      sendBiankaImpression({
        eventName: EVENT_NAMES.BIANKA.SOCIAL_PROOF_IS_SHOWN,
        componentName: 'social_proof',
        componentText: 'TrustedBy',
        isV16,
      });
    },
  });

  useEffect(() => {
    const checkScreenSize = () => {
      setIsLargeScreen(window.innerWidth > 1400);
    };

    checkScreenSize();
    window.addEventListener('resize', checkScreenSize);

    return () => {
      window.removeEventListener('resize', checkScreenSize);
    };
  }, []);

  useEffect(() => {
    if (!isLargeScreen) {
      intervalRef.current = setInterval(() => {
        setCurrentSlideIndex((prevIndex) => (prevIndex + 1) % TRUSTED_COMPANIES.length);
      }, 3000);

      return () => {
        if (intervalRef.current) {
          clearInterval(intervalRef.current);
        }
      };
    } else if (intervalRef.current) {
      clearInterval(intervalRef.current);
      intervalRef.current = null;
    }
  }, [isLargeScreen]);

  const getBreakpoints = () => {
    if (isLargeScreen) {
      return { default: TRUSTED_COMPANIES.length };
    }
    return {
      default: 2,
      sm: 4,
      md: 5,
      xl: 6,
    };
  };

  return (
    <Container
      as="section"
      ref={observableRef}
      paddingBottom={{
        default: '4',
        md: '10',
        lg: '12',
        xl: '20',
      }}
      paddingTop={{
        default: '4',
        md: '10',
        lg: '12',
        xl: '24',
      }}
      className={sectionCustomClass}
    >
      <Carousel breakpoints={getBreakpoints()} scrollToSlideIndex={!isLargeScreen ? currentSlideIndex : undefined}>
        <Track>
          {TRUSTED_COMPANIES.map((company) => (
            <Slide key={company.id}>
              <Image src={company.image} alt={company.name} height={{ default: 72, lg: 90 }} objectFit="contain" />
            </Slide>
          ))}
        </Track>
      </Carousel>
    </Container>
  );
};

export default TrustedBy;
